import { AdminFinanceWebService } from '@linktivity/gds-neo';

export const InvoiceStatusCounts =
  AdminFinanceWebService.ListOtaWithChargeSummaryStatusEnum;

export const InvoiceStatus = AdminFinanceWebService.InvoiceStatus;
export const WalletOrderStatus = AdminFinanceWebService.WalletOrderStatus;

export const InvoicePaymentType =
  AdminFinanceWebService.ListOtaWithChargeSummaryPaymentTypeEnum;
export type InvoicePaymentType =
  AdminFinanceWebService.ListOtaWithChargeSummaryPaymentTypeEnum;

export const InvoicePaymentPeriod =
  AdminFinanceWebService.ListOtaWithChargeSummaryPaymentPeriodEnum;
export type InvoicePaymentPeriod =
  AdminFinanceWebService.ListOtaWithChargeSummaryPaymentPeriodEnum;

export const InvoiceType =
  AdminFinanceWebService.ListInvoicesWithPageInvoiceTypeEnum;
export type InvoiceType =
  AdminFinanceWebService.ListInvoicesWithPageInvoiceTypeEnum;

export const ListWalletOrdersTypeEnum =
  AdminFinanceWebService.ListWalletOrdersTypeEnum;

export const ListWalletOrderFormatTypeEnum =
  AdminFinanceWebService.ListWalletOrderFormatTypeEnum;

export const WalletOrderType = AdminFinanceWebService.WalletOrderType;
export type WalletOrderType = AdminFinanceWebService.WalletOrderType;
